import Model from 'ln/model/Model';

export default class AudioTipModel extends Model {

    readonly audio:Asset;
    readonly top:number;
    readonly left:number;

    playing:boolean;

    constructor( obj:any ) {
        super( { playing: false, ...obj } );
    }
}

interface Asset {
    file_name:string;
    ext:string;
}
